module.exports = __webpack_public_path__ + "ms-logo-0c29638c7558632a1a5f053d344405ba.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/microsoft_assets/ms-logo.png
// module id = /V75
// module chunks = client